// @flow

import type { ProductPrice } from '@gandi/cart';

import { DomainRow } from './DomainRow';

export type Props = {
  prices: Array<ProductPrice>,
  domains: Array<string>,
};

export const DomainsByProcess = ({ prices, domains }: Props): React.Node => {
  if (prices.length === 0) {
    if (domains.length === 0) return null;

    return <DomainRow matchedDomains={domains} />;
  }

  return prices.map(price => {
    const process = price.process;
    if (!process) return null;

    const isWildcard = process.includes('wildcard');
    const matchedDomains = domains.filter(d =>
      isWildcard ? d.startsWith('*.') : !d.startsWith('*.'),
    );

    return (
      <DomainRow
        key={process}
        matchedDomains={matchedDomains}
        isWildcard={isWildcard}
        price={price.base_price}
      />
    );
  });
};
